





















import { Component, Vue, Prop} from 'vue-property-decorator';
import { Player } from '@/game/player';
import { Ball } from '@/game/ball';
import { EventBus } from '@/event-bus';
import Effects from '@/views/Effects.vue';

@Component({
  name: 'field',
  components: {
    effects: Effects
  }
})
export default class Field extends Vue {

  @Prop() public playerIndex!: number;
  @Prop() public players!: Player[];
  @Prop() public balls!: Ball[];

  public size = 300;
  public sliderSize = 50;

  public showTargets = false;

  private playerDir: 'left' | 'right' | 'stop' = 'stop';

  get count() {
    return this.players.length;
  }

  public mounted() {
    console.log(this.$refs['field-container']);
    EventBus.$on('hit', (player: Player) => {
      console.log(player.name + ' hit the ball');
      this.animate(player, 'rubberBand');
    });
    EventBus.$on('lost', (player: Player) => {
      console.log(player.name + ' lost');
      this.animate(player, 'wobble');
    });
  }

  public animate(player: Player, animation: string) {
    const el = document.querySelector('#player-' + player.id) as HTMLElement;

    if (el) {
      el.className = 'label animated fast';
      void el.offsetWidth;
      el.classList.add(animation);
      el.style.webkitAnimationPlayState = 'running';
    }
  }

  public sliderStyle(player: Player) {
    let style = 'background-color: ' + (player.color ? player.color : '#333') + ';';

    const pos = /* this.positions[i] */ player.pos || 0;
    style += 'transform: translate(-50%, -2px) translateX(' + pos + 'px);';

    style += `width: ${player.width}px;`;
    return style;
  }

  public playerStyle(i: number) {
    const rot = 360/this.count*i;
    const trans = this.size/2*Math.tan(Math.PI*(1/2-1/this.count));
    return 'transform: translate(-50%, -50%) rotate(' + rot + 'deg) translateY(' + trans + 'px)';
  }

  public arrowStyle(i: number) {
    const x = this.balls[i].vel.x, y = this.balls[i].vel.y;
    const rot = 180 / Math.PI * Math.sign(y) * Math.acos(x/Math.sqrt(Math.pow(x,2)+Math.pow(y,2))) - 90;
    return 'transform: translateX(-50%) rotate(' + rot + 'deg);';
  }

  public ballStyle(ball: Ball) {
    const d = 2 * ball.radius;
    return `width: ${d}px; height: ${d}px; transform: translate(-50%, -50%) translate(${ball.pos.x}px, ${ball.pos.y}px)`;
  }

  public fieldStyle() {
    const container = this.$refs['field-container'] as HTMLElement;
    if (!container) return '';
    const a = this.size, n = this.count;
    const size = a/Math.sin(Math.PI/n);
    const scale = 1/Math.max(size/(Math.min(container.offsetWidth, container.offsetHeight) - 50), 1);
    const rot = -360/this.count*this.playerIndex;
    return 'width: ' + size + 'px; height: ' + size + 'px; transform: translate(-50%, -50%) rotate(' + rot + 'deg) scale(' + scale + ');';
  }

  public length(x: number, y: number): number {
    return Math.sqrt(Math.pow(x,2)+Math.pow(y,2));
  }

  public control(player: Player, dir: 'left' | 'right', started: boolean, ev: TouchEvent) {
    if (player.isBot) { return; }

    ev.preventDefault();
    ev.stopPropagation();
    if (started) {
      player.setDirection(dir);
    } else {
      player.setDirection('stop');
    }
  }
}
